import axiosInstance from "@/api/axios"

// window.postMessage(JSON.stringify({method: 'login', queryPass: '123'}), "http://test.9wickets.com:5173/")

const useReceiveMessage = () => {
  const modalStore = useModalStore()

  function receiveMessage(e: MessageEvent) {
    // 基本安全檢查 - 可根據需要設定允許的 origins
    // if (e.origin !== "https://your-trusted-domain.com") {
    //   console.warn("Message from untrusted origin:", e.origin)
    //   return
    // }

    try {
      // 檢查是否為字串類型的 JSON 數據

      let data
      if (typeof e.data === "string") {
        data = JSON.parse(e.data)
      } else if (typeof e.data === "object") {
        data = e.data
      } else {
        console.warn("Unsupported message data type:", typeof e.data)
        return
      }

      if (data.method === "login") {
        axiosInstance.defaults.headers.common.Authorization = data.queryPass
      }

      if (data.method === "iframeClose") {
        modalStore.closeModal()
      }
    } catch (error) {
      console.warn("Failed to parse message data:", error)
      console.log("Raw data:", e.data)
    }
  }

  // 提供清理函數
  const cleanup = () => {
    window.removeEventListener("message", receiveMessage, false)
  }

  // 監聽 message 事件
  window.addEventListener("message", receiveMessage, false)

  onUnmounted(() => {
    cleanup()
  })

  return {
    receiveMessage,
    cleanup
  }
}

export default useReceiveMessage
